import commentsService from '@rd-web-markets/shared/dist/services/comments.service';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { createCommentSpans } from '../../comments/commentsDomUtils';
import { useErrorHandling } from '../../hooks/useErrorHandling';
import { Button } from '../buttons';
import CommentsSection from './modules/comments/CommentsSection';
import CreateComment from './modules/comments/CreateComment';
import { getContentStyle } from './trachChangesEditorStyles';
import { v4 as uuidv4 } from 'uuid';
import { Col, Row } from 'react-bootstrap';
export default function OnlyCommentsEditor(_ref) {
  let {
    getContentFn,
    updateContentFn,
    modelId,
    modelClass,
    modelField
  } = _ref;
  const [editorContent, setEditorContent] = useState('');
  const [isCommenting, setIsCommenting] = useState(false);
  const [selectedCommentsSpanId, setSelectedCommentsSpanId] = useState(null);
  const [comments, setComments] = useState([]);
  // const [textHighlightedForComment, setTextHighlightedForComment] = useState('')
  const [editorSelection, setEditorSelection] = useState(null);
  const editorBodyRef = useRef();
  const fetchComments = useErrorHandling(useCallback(async () => {
    const result = await commentsService.all(modelId, modelClass, selectedCommentsSpanId, modelField);
    setComments(result.comments);
    if (result.comments.length) {
      setIsCommenting(true);
    }
  }, [modelClass, modelField, modelId, selectedCommentsSpanId]));
  const setText = useErrorHandling(useCallback(async () => {
    const content = await getContentFn();
    setEditorContent(content);
  }, [getContentFn, setEditorContent]));
  useEffect(() => {
    setText();
  }, [setText]);
  useEffect(() => {
    fetchComments();
  }, [fetchComments]);
  function onAddCommentButtonClick() {
    const documentTextSelection = document.getSelection();
    // setTextHighlightedForComment(documentTextSelection.toString())

    try {
      // dereference
      const {
        startOffset,
        endOffset,
        startContainer,
        endContainer
      } = documentTextSelection.getRangeAt(0);
      const selectionCopy = {
        anchorNode: documentTextSelection.anchorNode,
        anchorOffset: documentTextSelection.anchorOffset,
        focusNode: documentTextSelection.focusNode,
        focusOffset: documentTextSelection.focusOffset,
        getRangeAt: () => ({
          startOffset,
          endOffset,
          startContainer,
          endContainer
        })
      };
      setEditorSelection(selectionCopy);
    } catch (error) {
      if (!documentTextSelection.rangeCount) {
        // https://stackoverflow.com/questions/22935320/uncaught-indexsizeerror-failed-to-execute-getrangeat-on-selection-0-is-not
        // This is a webkit bug and in our case happens when nothing is selected.
        // We can safely ignore it.
        // Setting the selection to null, in order to add the comment to the whole section.
        setEditorSelection(null);
      }
    }
    setIsCommenting(true);
    setSelectedCommentsSpanId(uuidv4());
  }
  const createCommentHighlightAndUpdateContent = () => {
    // at this point the user has clicked on different places and de-selected the original selection many times
    // so we need to pass the original editorSelection
    if (editorSelection) {
      const resultContent = createCommentSpans(editorBodyRef.current, editorSelection, selectedCommentsSpanId);
      setEditorContent(resultContent);
      setEditorSelection(null);
      updateContentFn(resultContent);
    }
    fetchComments();
  };
  const setSelectedCommentsThreadIdIfClickedOnAComment = event => {
    const commentThreadId = event.target.getAttribute('data-aym-comment-id');
    setSelectedCommentsSpanId(commentThreadId || null);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("style", null, `
          ${getContentStyle(true)}
        `), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    md: {
      span: 3,
      offset: 9
    }
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: onAddCommentButtonClick
  }, "Add Comment"))), /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement("div", {
    ref: editorBodyRef,
    onClick: setSelectedCommentsThreadIdIfClickedOnAComment,
    dangerouslySetInnerHTML: {
      __html: editorContent
    }
  }), /*#__PURE__*/React.createElement("hr", null), isCommenting && /*#__PURE__*/React.createElement("div", {
    className: "p-3",
    style: {
      width: '300px',
      backgroundColor: 'white',
      zIndex: 100,
      border: '1px solid #0078b9',
      'margin-left': '5px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex mb-3",
    style: {
      justifyContent: 'space-between',
      borderBottom: '1px solid grey'
    }
  }, "COMMENTS", /*#__PURE__*/React.createElement("div", {
    onClick: () => setIsCommenting(false)
  }, "X")), /*#__PURE__*/React.createElement(CommentsSection, {
    comments: comments
  }), selectedCommentsSpanId && /*#__PURE__*/React.createElement(CreateComment, {
    modelClass: modelClass,
    modelId: modelId,
    modelField: modelField,
    spanId: selectedCommentsSpanId,
    onCreateComment: createCommentHighlightAndUpdateContent
  })));
}